import { Modal } from 'react-bootstrap';
import CloseButton from '../CloseButton';
import styled from 'styled-components';
import currency from 'currency.js';

const TableStatistics = styled.table`
    tr {
        border-bottom: 1px solid #E6E6E8;
        color: black;
    }

    tr:nth-child(4) {
        border-bottom: none;
    }

    tr:last-child {
        border-bottom: none;
        color: #5f5f5f;
        font-weight: 650;
    }

    tr > td:nth-of-type(2) {
        text-align: right;
    }
`;

const H4 = styled.h4`
    font-weight: 650;
`

const HeaderTitle = styled.div`
    font-size: 20px;
`

const PostStatistics = ({ post, show, setShow }) => {
    const handleClose = () => {
        setShow(false);
    };

    if (show) {
        return <Modal
            show={show}
            onHide={handleClose}
            className={'post-ppv-stats-modal'}
            centered
        >
            <Modal.Header className={'post-ppv-stats-modal-header'}>
                <HeaderTitle>POST PPV STATISTICS</HeaderTitle> <CloseButton
                    className="close"
                    onClick={handleClose}
                    style={{ position: 'absolute', top: 0, right: 12 }}
                />
            </Modal.Header>
            <Modal.Body>
                <TableStatistics className='post-statistics-table' width="100%" cellSpacing={0} cellPadding={4}>
                    <tbody className={'post-statistics-table-content'}>
                        <tr>
                            <td>Purchases</td>
                            <td>
                                {post.purchases_count} ({currency(post.transactions_sum_pu_total ?? 0).format({ precision: 2 })})
                            </td>
                        </tr>
                        <tr>
                            <td>Likes</td>
                            <td>{post.likes.length}</td>
                        </tr>
                        <tr>
                            <td>Comments</td>
                            <td>
                                {post.comments_count}
                            </td>
                        </tr>
                        <tr>
                            <td>Tips</td>
                            <td>
                                {post.tips_count} ({currency(post.tips_sum_pu_total ?? 0).format({ precision: 2 })})
                            </td>
                        </tr>

                        <tr>
                            <td>
                                <H4>Total earnings</H4>
                            </td>
                            <td>
                                {
                                    currency(parseFloat(post.tips_sum_pu_total ?? 0))
                                        .add(parseFloat(post.transactions_sum_pu_total ?? 0))
                                        .format({ precision: 2 })
                                }
                            </td>
                        </tr>
                    </tbody>
                </TableStatistics>
            </Modal.Body>
        </Modal>;
    }

    return '';
};

export default PostStatistics;
